import React from "react";
import Div from "../../../../widget/common/ui/Div";
import Center from "../../../../widget/common/ui/Center";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { textCase } from "../../../../service/ui/UI";
import { TextBlock } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import SettingsProvider from "../../../../provider/settings/settings/SettingsProvider";
import { AlertConfirm } from "../../../../widget/common/ui/Alerts";

const PROJECT_TITLE = process.env.REACT_APP_project_title ?? "communicatr";
const PROJECT_APP_VERSION = process.env.REACT_APP_version ?? "1.0.0";

const SettingsLogout = () => {
  const logout = () => {
    AlertConfirm({
      title: "are_you_sure_want_to_logout",
      onConfirm: () => SettingsProvider.logout(),
    });
  };

  return (
    <Div
      color="theme-label"
      fontSize="10_12"
      fontName="medium"
      className="d-center align-items-end"
    >
      <Div>
        <Center>
          <div role="button" onClick={() => logout()}>
            <Center>
              <IconCircleFilledIcon
                name="logout3"
                className="mx-1"
                size={25}
                handleClick={() => {}}
              />
            </Center>
            <SpacingHeight value={10} />
            <TextBlock
              fontName="bold"
              textColor="red2"
              fontSize="16_17"
              center={true}
            >
              {textCase(AppTranslation.text("logout"))}
            </TextBlock>
          </div>
        </Center>

        <SpacingHeight value={17} />
        <Center>
          version {PROJECT_APP_VERSION} | © {new Date().getFullYear()}{" "}
          {textCase(PROJECT_TITLE)}
        </Center>
      </Div>
    </Div>
  );
};

export default SettingsLogout;
